// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  background-color: #efeff7;
}
.holder {
  padding-left: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/app/property-module/properties-edit/properties-edit.component.less"],"names":[],"mappings":"AAEA;EACI,yBAAA;AADJ;AAIA;EACI,kBAAA;AAFJ","sourcesContent":["@import (reference) url('../../../styles.less');\n\nform {\n    background-color: @ltpurple;\n}\n\n.holder {\n    padding-left: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
